import { Cell } from './grid';
import { mulberry32 } from '../core/rng';
/** Ваги розподілу pickup-ів. Не нормалізовані. */
const WEIGHTS = [
    ['fire', 25],
    ['bomb', 25],
    ['speed', 20],
    ['wall_pass', 5],
    ['bomb_pass', 5],
    ['remote', 5],
    ['kick', 5],
    ['flame_pass', 3],
];
function pickWeighted(rand) {
    const total = WEIGHTS.reduce((s, [, w]) => s + w, 0);
    let n = rand() * total;
    for (const [kind, w] of WEIGHTS) {
        if ((n -= w) < 0)
            return kind;
    }
    return WEIGHTS[0][0];
}
/**
 * Зібрати всі клітинки SoftBlock у сітці.
 */
export function softBlockCells(grid) {
    const out = [];
    for (let r = 0; r < grid.rows; r++) {
        for (let c = 0; c < grid.cols; c++) {
            if (grid.get(c, r) === Cell.SoftBlock)
                out.push({ c, r });
        }
    }
    return out;
}
/**
 * Згенерувати план: 1 exit + N pickup-ів, усі під SoftBlock.
 * Детермінований за `seed`. Якщо SoftBlock-ів менше, ніж потрібно — план звужується.
 */
export function planLevel(grid, seed, pickupCount = 4) {
    const rand = mulberry32(seed ^ 0xa11c0ffee);
    const cells = softBlockCells(grid);
    const plan = new Map();
    if (cells.length === 0)
        return plan;
    // Перемішаємо (Fisher-Yates) і виберемо першу для exit.
    for (let i = cells.length - 1; i > 0; i--) {
        const j = Math.floor(rand() * (i + 1));
        [cells[i], cells[j]] = [cells[j], cells[i]];
    }
    const exitCell = cells[0];
    plan.set(`${exitCell.c},${exitCell.r}`, { kind: 'exit' });
    const want = Math.min(pickupCount, cells.length - 1);
    for (let i = 1; i <= want; i++) {
        const cell = cells[i];
        plan.set(`${cell.c},${cell.r}`, { kind: pickWeighted(rand) });
    }
    return plan;
}
export function key(c, r) {
    return `${c},${r}`;
}
